import type { PersonnelTmdPermission } from "src/api/Tmd.dtos";
import {
    LinkPermissionMode,
    type ILayoutItemContext,
    type ILayoutLink
} from "src/contexts/layouts/LayoutContext";

import hasAnyPermission from "./hasAnyPermission";
import hasEveryPermission from "./hasEveryPermission";

/**
 * Selects all-permission or any-permission evaluation for a layout link.
 *
 * Postconditions: All mode requires every permission; other modes use any matching permission.
 * Link scope mode and supplied context are delegated unchanged.
 */
const hasLayoutLinkPermission = (
    personnelPermissions: PersonnelTmdPermission[] | undefined,
    link: ILayoutLink,
    context?: ILayoutItemContext
): boolean =>
    link.permissionMode === LinkPermissionMode.All
        ? hasEveryPermission(
              personnelPermissions,
              link.permissions,
              context,
              link.permissionScopeMode
          )
        : hasAnyPermission(
              personnelPermissions,
              link.permissions,
              context,
              link.permissionScopeMode
          );

/**
 * Returns permitted links in original order, retaining the original link object references.
 */
export const filterLayoutLinksByPermission = (
    personnelPermissions: PersonnelTmdPermission[] | undefined,
    links: ILayoutLink[],
    context?: ILayoutItemContext
): ILayoutLink[] =>
    links.filter(link => hasLayoutLinkPermission(personnelPermissions, link, context));

export default hasLayoutLinkPermission;
